import React from 'react';
import styled from 'styled-components';
import { useSelector, useDispatch } from 'react-redux';
import { useState, useRef , useEffect} from 'react';
import {isMobileOnly} from 'react-device-detect';
import ProductDetail2 from '../../pages/pd/ProductDetail2';


const MyEsPopupPDStep4Block = styled.div`
    position: fixed;
    //background-color: rgba(17, 17, 17, 0.3);
    
    z-index: 100;
    ${isMobileOnly?`
    width: 100vw; 
    `:`
    width: 100%;
    height: 100%;
    `};
    
    ${isMobileOnly?`
    bottom: 0;
    transform: translateY(100vh);
    transition: transform 0.3s ease,opacity 0.3s ease;
    `:`
    top: 0;
    //left: -100%;
    transform: translateX(-100%);
    transition: transform 0.3s ease,opacity 0.3s ease;
    width: 100%;
    `};

    .close-pop {
        ${isMobileOnly?`
        height: calc(100vh - 510px);
        width: 100wh;  
        `:`
        //height: 100vh;
        width: calc(100% - 435px);
        `};
    }

    &.active {
        //display: block;
        
        ${isMobileOnly?`
        transform: translateY(0px);
        height: 100vh; 
        `:`
        transform: translateX(0);
        width: 100%;
        display: block;
        `};
    }

    &.active-no {
        
        ${isMobileOnly?`
        transform: translateY(100vh);
        //height: 0vh;
        height: 100vh;
        `:`
        transform: translateX(-100%);
        //height: 0vh;
        width: 100%;
        display: none;
        `};
    }

    &.hide {
        display:none;
    }

    .cate {
        
    }

`;

const MyEsPCPopupContainerBlock = styled.div`
    .left_con {
        height: 100vh;
        background-color: #ffffff;
        float: left;
        width: 800px;
        overflow: scroll;

        .close_btn {
            margin-top: 22px;
            margin-left: 745px;
            width: 36px;
            height: 36px;
            background: url(/assets/images/icon/pp_btn_delete.png) center center/auto no-repeat;
            margin-bottom: 12px;
            background-size: 14px 14px;
        }
    }

    .right_con {
        float: left;
        height: 100vh;
        width: calc(100% - 800px);
        .continue {
            font-size: 52px;
            font-weight: normal;
            line-height: 100vh;
            color: #ffffff;
            margin-left: 60px;
            font-family: 'Dancing Script',cursive;
        }
    }
`;

const MyEsPopupPDStep4ContainerBlock = styled.div`
    ${isMobileOnly?`
    height: 510px;
    `:`
    //height: 650px;
    `};
    display: ${props => props.display || 'none'};
    color: #111111;
    position: relative;
    //top: calc(100vh - 500px);

    .top-blank {
        height: 10px;
        width: 100vw;
    }
    .top-bar {
        border-radius: 4px;
        background-color: #ffffff;
        width: 50px;
        height: 8px;
        margin: 0 auto;
        margin-bottom: 10px;
    }
    .container {
        ${isMobileOnly?`
        background-color: #ffffff;
        border-top-right-radius: 12px;
        border-top-left-radius: 12px;
        padding: 26px 4vw 0;
        height: 490px;
        `:`
        padding: 0px 40px 0px;
        `};
    }

    .title {
        ${isMobileOnly?`
        font-size: 16px;
        text-align: center;
        margin-bottom: 20px; 
        `:`
        font-size: 18px;
        margin-bottom: 40px; 
        `};

        font-weight: bold;
        height: 24px;
        position: relative;

        
    }

    .back {
        ${isMobileOnly?`
        top: -7px;
        left: -4vw;
        `:`
        top: -78px;
        left: -14px;
        `};
        width: 36px;
        height: 36px;
        position: absolute;
        
        background: url(/assets/images/icon/back_btn.svg) center center/auto no-repeat;
    }
    
    .cate1 {
        ${isMobileOnly?`
        font-size: 14px;
        margin-bottom: 16px;
        `:`
        font-size: 18px;
        margin-bottom: 20px;
        `};
        
        font-weight: normal;
        height: 20px;
        line-height: 20px;
        
        ::after {
            content: '';
            display: inline-block;
            width: 5px;
            height: 10px;
            position: absolute;
            ${isMobileOnly?`
            right: 4vw;
            `:`
            right: 40px;
            `};
            
            margin-top: 5px;
            background: url(/assets/images/icon/arrow_right.svg) center center/cover no-repeat;
            -webkit-transform: rotate(360deg);
            -ms-transform: rotate(360deg);
            -webkit-transform: rotate(360deg);
            -ms-transform: rotate(360deg);
            -webkit-transform: rotate(360deg);
            -ms-transform: rotate(360deg);
            -webkit-transform: rotate(360deg);
            -ms-transform: rotate(360deg);
            transform: rotate(360deg);
    }

    .num {
        ${isMobileOnly?`
        font-size: 13px;
        margin-left: 4px;
        `:`
        font-size: 20px;
        margin-left: 10px;
        `};
        
        font-weight: 500;
        color: #fc7a35;
        //line-height: 2;
    }

`;


const MyEsPopupPDStep4 = ({id, handleClosePopup, active}) => {
    const refbox = useRef(null);
    const refContainer = useRef(null);
    const dispatch = useDispatch();
    const [startY, setStartY] = useState(0);
    const [moveY, setMoveY] = useState(0);

    const { categoryItems, esMyBrandCate1Step, esBrandNumStep3} = useSelector(
        ({ cateItemsReducer, esMyReducer }) => ({
            categoryItems: cateItemsReducer.cateItems,
            esMyBrandCate1Step: esMyReducer.esMyBrandCate1Step,
            esBrandNumStep3: esMyReducer.esBrandNumStep3,
        })
    );

    useEffect(() => {
        const handleEnd = (e) => {
            if(isMobileOnly) {
                if(refbox.current.getBoundingClientRect().top > 100) {
                    refbox.current.classList.add('hide');
                } else {
                    refbox.current.classList.remove('hide');
                }
            }
            //console.log("transitionend = " + JSON.stringify(refbox.current.getBoundingClientRect()));
            
        }

        document.addEventListener("transitionend", handleEnd);
        return () => {
            // Unbind the event listener on clean up
            document.removeEventListener("transitionend", handleEnd);
        };
    }, []);

    useEffect(() => {
        if(refbox && refbox.current) {
            if(active) {
                refbox.current.classList.remove('hide');
                refbox.current.classList.remove('active-no');
                setTimeout(() => {
                    refbox.current.classList.add('active');
                }, 10);

                if(isMobileOnly) {
                    document.body.style.overflow = 'hidden';
                    document.body.style.position= 'fixed';
                } else {
                    document.body.style.overflow = 'hidden';
                }
                
            } else {
                refbox.current.classList.remove('active');
                refbox.current.classList.add('active-no');

                if(isMobileOnly) {
                    document.body.style.overflow = 'unset';
                    document.body.style.position= 'relative';
                } else {
                    //document.body.style.overflow = 'auto';
                    document.body.removeAttribute('style')
                }
                
            }
        }
    }, [active]);



    const onClick = (e) => {
        //e.stopPropagation();
        if(handleClosePopup !== null && handleClosePopup !== undefined) {
            handleClosePopup();
        }
        
    }


    const touchY = (event) => {
        //return;
        if ("touches" in event && event.touches.length >= 1) {
            const { clientX, clientY } =
            "touches" in event ? event.touches[0] : event;

            return clientY;
        }
        return;
    }

    const touchCancel = (e) => {
        
    }

    const touchEnd = (e) => {
        if(isMobileOnly && startY > 0) {
            //if(moveY - startY > 70) {
                if(handleClosePopup !== null && handleClosePopup !== undefined) {
                    handleClosePopup();
                }
            //}
        }

        setMoveY(0);
        setStartY(0);
    }

    const touchMove = (e) => {
        if(isMobileOnly && startY > 0) {
            let moveY = touchY(e);
            setMoveY(moveY);
        }
    }

    const touchStart = (e) => {

        if(isMobileOnly && refContainer && refContainer.current){
            let startY = touchY(e);
            //console.log('topY = ' + refContainer.current.getBoundingClientRect().top)

            if(startY - refContainer.current.getBoundingClientRect().top < 40) {
                setStartY(startY);
            }
        }
    }

    return (
        <MyEsPopupPDStep4Block  ref={refbox} >
            <MyEsPCPopupContainerBlock className="small_scroll">
                <div className="left_con">
                    <button className="close_btn" onClick={onClick}></button>
                    {
                        active?
                        <MyEsPopupPDStep4ContainerBlock display={active? 'block':'none'}ref={refContainer} onTouchStart={touchStart} onTouchMove={touchMove} onTouchEnd={touchEnd} onTouchCancel={touchCancel}>
                            <ProductDetail2 pd_id={id} handleClosePopup={onClick}></ProductDetail2>
                        </MyEsPopupPDStep4ContainerBlock>
                    :
                    ''
                    }
                    
                </div>
                <div className="right_con" onClick={onClick}>
                            <div className="continue">continue&gt;</div>
                </div>
            </MyEsPCPopupContainerBlock>
            
        </MyEsPopupPDStep4Block>
    );
};

export default MyEsPopupPDStep4;